import { useEffect, useState } from "preact/hooks";
import { nostojs } from "@nosto/nosto-js";
import { JSONProduct } from "@nosto/nosto-js/client";
import DynamicProduct from "@/components/Product/DynamicCardProduct";

export default function RecommendationProducts({
  placementId,
}: {
  placementId: string;
}) {
  const [title, setTitle] = useState<string | undefined>("");
  const [products, setProducts] = useState<JSONProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    nostojs((api) => {
      api
        .defaultSession()
        .viewOther()
        .setPlacements([placementId])
        .load()
        .then(async (response: any) => {
          const recommendations = response?.recommendations;
          if (!recommendations) return;
          const recommendation = recommendations[placementId];
          if (recommendation?.products) {
            setTitle(recommendation?.title);
            setProducts(recommendation?.products);
          }
        });
    });
  }, []);
  useEffect(() => {
    if (products.length > 0) {
      setLoading(false);
    }
  }, [products]);

  return (
    <div className="plp" data-nosto-element="category">
      {title && (
        <div className="plp__heading">
          <h2 className="h3">{title}</h2>
        </div>
      )}
      <div className="plp__grid">
        {!loading &&
          products.map((product, index) => (
            <div className="plp__grid-item" key={product.product_id}>
              <DynamicProduct
                product={product}
                index={index}
                searchTrackType={null}
              />
            </div>
          ))}
      </div>
    </div>
  );
}
